<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-checkboxes-filter label="State" name="jobFarmInstanceState" [options]="stateOptions"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Last seen" name="lastSeen" [options]="lastSeenOptions"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-job-farm-instances-table></cm-job-farm-instances-table>
</cm-sidebar-layout>

<router-outlet></router-outlet>
